module.exports = __webpack_public_path__ + "static/media/f10.18e9d717.png";